export function resolveOrpcPathFromRequestUrl(url: string): string | null {
	try {
		const pathname = new URL(url, "http://localhost").pathname;
		const marker = "/api/rpc/";
		const index = pathname.indexOf(marker);
		if (index < 0) {
			return null;
		}
		const path = pathname.slice(index + marker.length);
		return path.length > 0 ? path : null;
	} catch {
		return null;
	}
}

/**
 * Format oRPC link interceptor `path` segments into a stable procedure label.
 * Prefer this over any shared "last request" slot — concurrent RPCs race that.
 */
export function formatOrpcProcedurePath(
	path: readonly string[] | null | undefined,
): string | undefined {
	if (path == null || path.length === 0) {
		return undefined;
	}
	const joined = path.filter((segment) => segment.length > 0).join("/");
	return joined.length > 0 ? joined : undefined;
}
